module.exports = __webpack_public_path__ + "static/img/17-Kingswood-HQ-redevelopment.e55adf8d.jpg";